<div class="spinner-wrapper" *ngIf="(isActive$ | async)">
    <div class="spinner">
        <div class="spinner-ring">
            <div></div>
            <div></div>
        </div>
    </div>
</div>
